(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[42],{

/***/ 3094:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/exercises/[slug]",
      function () {
        return __webpack_require__(8636);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 8636:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; },
/* harmony export */   "default": function() { return /* binding */ ExercisePage; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1527);
/* harmony import */ var components_layout_PageLayout__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2582);
/* harmony import */ var content_links__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2304);
/* harmony import */ var content_text__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9862);




var __N_SSG = true;
function ExercisePage(param) {
    var exerciseElement = param.exerciseElement;
    var name = exerciseElement.name, tags = exerciseElement.tags, youtubeLink = exerciseElement.youtubeLink, slug = exerciseElement.slug;
    var newUrl = new URL(youtubeLink);
    var videoId = newUrl.pathname.substring(1);
    var timestamp = newUrl.searchParams.get("t");
    var og = {
        site_name: content_text__WEBPACK_IMPORTED_MODULE_3__/* .seo.title */ .$K.title,
        title: name + " - " + content_text__WEBPACK_IMPORTED_MODULE_3__/* .seo.title */ .$K.title,
        description: "Camp Knut" + name,
        type: "video.other",
        url: content_links__WEBPACK_IMPORTED_MODULE_2__/* .baseUrl */ .FH + "/exercises/" + slug
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_layout_PageLayout__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
        openGraph: og,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                    className: "text-3xl font-bold text-knut-light-text dark:text-knut-dark-text",
                    children: name
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "mt-5 flex flex-col gap-16 md:flex-row",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "relative col-span-2 aspect-video w-full",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("iframe", {
                            width: "100%",
                            height: "100%",
                            src: "https://www.youtube.com/embed/".concat(videoId, "?start=").concat(timestamp),
                            title: name,
                            frameBorder: "0",
                            allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
                            allowFullScreen: true,
                            className: "mx-auto mt-10 mb-5"
                        })
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                            className: "text-2xl pb-4 font-medium text-knut-light-header dark:text-knut-dark-header",
                            children: "Muscle groups:"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: "text-knut-light-header dark:text-knut-dark-header",
                            children: tags === null || tags === void 0 ? void 0 : tags.map(function(e) {
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    className: "mr-2 rounded-xl bg-sky-200 p-1 px-3 dark:bg-knut-dark-tag",
                                    children: e
                                }, e);
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                            className: "text-2xl pt-5 font-medium text-knut-light-header dark:text-knut-dark-header",
                            children: "Youtube link:"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            target: "_blank",
                            rel: "noreferrer",
                            className: "text-knut-light-header hover:font-black dark:text-knut-dark-header",
                            href: youtubeLink,
                            children: youtubeLink
                        })
                    ]
                })
            ]
        })
    });
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [154,555,131,774,888,179], function() { return __webpack_exec__(3094); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);